import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import jwtEncode from "jwt-encode";
import { SideNav, SimApps } from "../../Assets/iconshere";
import { defaultLogo } from "../../env";
import { useLocation, useNavigate } from "react-router-dom";
import { removeUser } from "../../Store/slice/userSlice";
import apiClient from "../../apiClient";

const Header = ({ sideBar, setSideBar, setHomePage }) => {
  const path = window.location.pathname;
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const configData = useSelector((state) => state.configSlice);
  const nameParts = userData.token?.length > 0 ? userData?.user?.name?.split(" ") : "";
  const placeholder =
    nameParts?.length > 0
      ? nameParts?.length >= 2
        ? `${nameParts[0][0]}${nameParts[1][0]}`
        : `${nameParts[0][0]}`
      : "";
  const applications = useSelector((state) => state.applicationSlice).apps;
  const [showSideBarOrBtn, setShowSideBarOrBtn] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleUserLogOut = async () => {
    try {

      await apiClient.post(`${configData?.config.UNO_URL}/api/auth/logout`, {});

      // await axios.post(
      //   `${configData?.config.UNO_URL}/api/auth/logout`,
      //   {},
      //   {
      //     headers: {
      //       Authorization: `Bearer ${userData.token}`,
      //     },
      //   }
      // );
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(removeUser());
      localStorage.clear();
      sessionStorage.clear();
      if (configData.visibleSections.includes("home")) {
        navigate("/");
      } else {
        const payload = {
          logout: true
        };
        const token = jwtEncode(payload, "");
        window.location.href = `${configData.config.redirectUri}?referrer=${token}`;
      }
    }
  };

  const redirectApplication = (link) => {
    if (userData?.token && link) {
      const payload = { token: userData?.token };
      const token = jwtEncode(payload, "");

      if (link.includes("apps.simulanis.io")) {
        const newUrl = `${link}`;
        window.location.href = newUrl;
      } else {
        const newUrl = `${link}?referrer=${token}`;
        window.location.href = newUrl;
      }
    }
  };

  const handleLoginUser = () => {
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
    };
    const token = jwtEncode(payload, "");
    return (window.location.href = `${configData.config.redirectUri}?referrer=${token}`);
  };

  const handleGoToDashboard = () => {
    navigate(`/dashboard/${userData.user.uuid}`, { state: userData.user });
  };

  useEffect(() => {
    const showDashboardBtn = path === "/" || path.startsWith("/play/") || path.startsWith("/invite/");

    setShowSideBarOrBtn(showDashboardBtn);
    if (showDashboardBtn) {
      setSideBar(true);
    }
    setHomePage(path === "/" ? true : false);
  }, [path]);

  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : ""}`}>
        <div className="sidetoggle">
          {!showSideBarOrBtn && (
            <div
              className={sideBar ? "ps-1 activebar sidesvgdiv" : " sidesvgdiv ps-1"}
              onClick={() => {
                setSideBar(!sideBar);
                if (sideBar) {
                  document.body.classList.add("body-lock");
                } else {
                  document.body.classList.remove("body-lock");
                }
              }}
              style={{ width: "25px", height: "25px" }}
            >
              <SideNav />
            </div>
          )}

          <div className="mainlogo LOGOHERE" onClick={() => navigate("/")}>
            <img
              src={configData.config.logo}
              onError={(e) => {
                e.target.src = defaultLogo;
                e.onerror = null;
              }}
              referrerPolicy={"no-referrer"}
              alt=""
            />
            <p>{configData.config.name}</p>
          </div>
        </div>

        <div className="leftmain">
          {isLoggedIn && (
            <div className="profile">
              {showSideBarOrBtn && (
                <div className="log-sub">
                  <button
                    className="backtodashboard"
                    onClick={() => {
                      handleGoToDashboard();
                      setSideBar(false);
                    }}
                  >
                    Dashboard
                  </button>
                </div>
              )}

              <div className="dropdown profileavatar">
                <p className="d-none d-md-block">{userData?.user?.name || ""}</p>

                <button
                  className="btn btn-secondary dropdown-toggle themetoggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="useravatar">
                    {userData?.user?.avatar?.length > 0 ? (
                      <img
                        src={userData?.user?.avatar}
                        alt="Profile Image"
                        title={userData?.user?.name || null}
                        className="profilepik"
                        referrerPolicy={"no-referrer"}
                      />
                    ) : (
                      <div className="avatar-placeholder">{placeholder.toUpperCase()}</div>
                    )}
                  </div>
                </button>

                <div className="dropdown-menu themehere popupon">
                  <div className="profilemenuhead" tabIndex="0">
                    {userData?.user?.avatar?.length > 0 ? (
                      <img
                        src={userData?.user?.avatar}
                        alt="Profile Image"
                        title={userData?.user?.name || null}
                        className="profilepik"
                        referrerPolicy={"no-referrer"}
                      />
                    ) : (
                      <div className="avatar-placeholder">{placeholder.toUpperCase()}</div>
                    )}

                    <div className="profilemenudata">
                      <p>{userData?.user?.name || ""}</p>
                      <p>{userData?.user?.email || null}</p>
                    </div>
                  </div>
                  <p className="logoutbtn" onClick={handleUserLogOut}>
                    Log out
                  </p>
                </div>
              </div>

              <div className="dropdown profileavatar appnavigator">
                <button
                  className="btn btn-secondary dropdown-toggle themetoggle "
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <SimApps />
                </button>

                <div className="dropdown-menu themehere popupon">
                  <div className="menu-long">
                    <div className={applications.length > 2 ? "menubg extraspace" : "menubg"}>
                      {applications.map((e, index) => {
                        if (e.uuid === configData.config.applicationId) return null;
                        return (
                          <div
                            onClick={() => redirectApplication(e.channel?.origins[0]?.url)}
                            key={index + 1}
                            className="appshere"
                          >
                            <img
                              src={e.icon || defaultLogo}
                              onError={(e) => {
                                e.target.src = { defaultLogo };
                                e.onerror = null;
                              }}
                              alt=""
                              referrerPolicy={"no-referrer"}
                            />
                            <p>{e.name}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!isLoggedIn && (
            <div className="log-sub me-3">
              <button className="backtodashboard" onClick={handleLoginUser}>
                Login
              </button>
            </div>
          )}
        </div>
      </header>

      {window.innerWidth <= 767 && (
        <div
          onClick={() => {
            setSideBar(!sideBar);
            if (!sideBar) {
              document.body.classList.add("body-lock");
            } else {
              document.body.classList.remove("body-lock");
            }
          }}
          className={sideBar ? "overlaysidebar active" : "overlaysidebar"}
        ></div>
      )}
    </>
  );
};

export default Header;
